import { Alert, Button, Grid2, Typography } from "@mui/material";
import { useMemo, useState } from "react";

import { DjangoPaginationAdapter } from "api/common/adapters/pagination.adapters";
import { TableQueryParams } from "api/common/adapters/pagination.types";
import { createQueryAdapter } from "api/common/adapters/queryParam.adapter";
import {
  useDeleteOrgDocMutation,
  useGetOrgDocsQuery,
} from "api/memberPortal/orgs/orgDocs.api";
import { OrgDoc } from "api/memberPortal/orgs/orgs.types";
import DeleteModal from "components/UI/DeleteModal";

import SerialNumberModal from "../components/SerialNumberModal";

import SerialNumberTable from "./SerialNumber.table";

const orgDocApiAdapter = createQueryAdapter({
  paginationAdapter: DjangoPaginationAdapter,
});

// TODO: Make this common
type AlertType = {
  message: string;
  type: "error" | "success";
};

const SerialNumberTableContainer = () => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState<OrgDoc | null>(null);
  const [alert, setAlert] = useState<AlertType>();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [tableParams, setTableParams] = useState<TableQueryParams>({
    page: 0,
    pageSize: 100,
    sort: { field: "fullsn", direction: "desc" },
    search: "",
  });
  const orgDocQueryParams = useMemo(() => {
    return orgDocApiAdapter.toTableParams({
      pagination: tableParams,
    });
  }, [tableParams]);

  const resetAlerts = () => setAlert(undefined);

  const { data: orgDocs, isFetching: isFetchingOrgDocs } =
    useGetOrgDocsQuery(orgDocQueryParams);

  const handleShowEdit = (_document: OrgDoc | null) => {
    setSelectedDoc(_document);
    setShowEditModal(!showEditModal);
  };
  const [triggerDelete] = useDeleteOrgDocMutation();

  const handleDeleteDoc = async () => {
    const id = selectedDoc?.snid ?? false;
    if (!id) return;
    await triggerDelete(id);
    setShowDeleteModal(false);
  };

  return (
    <>
      {showDeleteModal && (
        // @ts-ignore still need to work on this modal later
        <DeleteModal
          show={showDeleteModal}
          handleClose={() => setShowDeleteModal(false)}
          type="Document Serial Number"
          deleteFunction={handleDeleteDoc}
        />
      )}
      <SerialNumberModal
        show={showEditModal}
        serialNumberToEdit={selectedDoc}
        handleClose={() => handleShowEdit(null)}
        setAlert={setAlert}
      />
      {alert && (
        <Alert sx={{ marginY: 2 }} severity={alert.type} onClose={resetAlerts}>
          {alert.message}
        </Alert>
      )}
      <Grid2 container justifyContent={"space-between"}>
        <Grid2>
          <Typography variant="h3">CCEVS Document Serial Number</Typography>
        </Grid2>
        <Grid2>
          <Button variant="contained" onClick={() => handleShowEdit(null)}>
            + Add
          </Button>
        </Grid2>
      </Grid2>
      <SerialNumberTable
        documents={orgDocs}
        isLoading={isFetchingOrgDocs}
        setShowEditModal={setShowEditModal}
        setDocument={setSelectedDoc}
        onTableParamsChange={setTableParams}
        tableParams={tableParams}
        setShowDeleteModal={setShowDeleteModal}
      />
    </>
  );
};

export default SerialNumberTableContainer;
